import { render, staticRenderFns } from "./TaxjarRoutes.vue?vue&type=template&id=b6b816e4"
import script from "./TaxjarRoutes.vue?vue&type=script&lang=js"
export * from "./TaxjarRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports